import { domReady } from './helpers';
import { getModal, MODAL_EVENTS } from './modal';

domReady(() => {
  // Allowed modals to be opened via url hash.
  // `callRequest` is handled in `shared.js` to guarantee React mount before opening.
  const modals = ['legalNotice', 'cguNotice', 'rgpdNotice'];

  function openModalFromHash() {
    // Remove '#' from hash
    const name = window.location.hash.substring(1);

    if (modals.includes(name)) {
      const el = document.getElementById(name);
      if (el) {
        const expectedHash = `#${name}`;
        el.addEventListener(
          MODAL_EVENTS.HIDDEN,
          () => {
            // clean current url by removing hash
            if (window.location.hash === expectedHash) {
              window.history.replaceState(
                null,
                '',
                `${window.location.pathname}${window.location.search}`
              );
            }
          },
          { once: true }
        );
        getModal(el)?.show();
      }
    }
  }

  // Open modals on hash change
  window.addEventListener('hashchange', openModalFromHash, false);

  // Open modals at DOM ready
  openModalFromHash();

  // Modals with `data-ui-show` attr will be opened on DOM ready
  [...document.querySelectorAll('.ui-modal[data-ui-show]')].forEach((modal) => {
    getModal(modal)?.show();
  });
});
